const scheduleModal = document.getElementById('schedule-modal');
if (scheduleModal) {
    const dateTrack    = document.getElementById('schedule-date-track');
    const prevBtn      = document.getElementById('schedule-date-prev');
    const nextBtn      = document.getElementById('schedule-date-next');
    const dateInput    = document.getElementById('scheduletourform-preferred-date');
    const videoOption  = document.getElementById('schedule-video-option');
    const step1        = document.getElementById('schedule-step-1');
    const step2        = document.getElementById('schedule-step-2');
    const stepNextBtn  = document.getElementById('schedule-step-next');
    const editBtn      = document.getElementById('schedule-edit-step');
    const dateDisplay  = document.getElementById('schedule-requested-date-display');
    const step1Error   = document.getElementById('schedule-step1-error');

    // ─── Tour hours (drives disabling unavailable dates/times) ────────────────
    // data-tour-hours (fischerhomes_tags.py's tour_hours_json) is only present
    // when {% if location|has_tour_hours %} -- absent entirely (tourHours stays
    // null) means "no known hours to restrict by", leaving every date/time
    // enabled exactly like before this feature existed.
    const scheduleFormEl = document.getElementById('scheduletourform');
    let tourHours = null;
    if (scheduleFormEl?.dataset.tourHours) {
        try {
            tourHours = JSON.parse(scheduleFormEl.dataset.tourHours);
        } catch (e) {
            tourHours = null;
        }
    }

    function getHoursForDay(jsDay) {
        return tourHours ? tourHours[jsDay] : null;
    }

    function isDayAvailable(d) {
        return !tourHours || !!getHoursForDay(d.getDay());
    }

    // Time options sit on a fixed 30-minute grid (see SCHEDULE_TOUR_TIMES in
    // constants.py), so "round up to the next slot" is just rounding up to :00/:30.
    const SLOT_INTERVAL_MINUTES = 30;
    const MIN_BUFFER_MINUTES    = 60;

    function isSameDay(a, b) {
        return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
    }

    // Earliest "HH:MM" selectable right now: current time plus a one-hour buffer,
    // rounded up to the next slot on the picker's grid (e.g. 1:45pm -> 3:00pm).
    function getMinTimeToday() {
        const now = new Date();
        let minutes = now.getHours() * 60 + now.getMinutes() + MIN_BUFFER_MINUTES;
        const remainder = minutes % SLOT_INTERVAL_MINUTES;
        if (remainder !== 0) minutes += SLOT_INTERVAL_MINUTES - remainder;
        const h = String(Math.floor(minutes / 60) % 24).padStart(2, '0');
        const m = String(minutes % 60).padStart(2, '0');
        return `${h}:${m}`;
    }

    const tourTypeRadios = scheduleModal.querySelectorAll('[name="tour_type"]');
    const tourNavTab       = document.getElementById('tour-nav-tab');
    const selfGuidedNavTab = document.getElementById('self-guided-nav-tab');
    const scheduleTabs     = document.getElementById('schedule-tabs');

    // ─── Toggle slider ──────────────────────────────────────────────────────────

    if (scheduleTabs) {
        scheduleTabs.querySelectorAll('[data-bs-toggle="tab"]').forEach(btn => {
            btn.addEventListener('shown.bs.tab', function () {
                scheduleTabs.classList.toggle('is-tab-2-active', this.id === 'self-guided-nav-tab');
            });
        });
    }

    const DAYS_SHOWN   = 3;
    const TOTAL_DAYS   = 14;
    const DAY_NAMES    = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
    const MONTH_NAMES  = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    let offset        = 0;
    let selectedIndex = 0;

    // ─── Dates ────────────────────────────────────────────────────────────────

    function getDate(dayOffset) {
        const d = new Date();
        d.setHours(0, 0, 0, 0);
        d.setDate(d.getDate() + dayOffset);
        return d;
    }

    function formatDateValue(d) {
        return [
            d.getFullYear(),
            String(d.getMonth() + 1).padStart(2, '0'),
            String(d.getDate()).padStart(2, '0'),
        ].join('-');
    }

    function renderDates() {
        dateTrack.innerHTML = '';
        for (let i = offset; i < offset + DAYS_SHOWN; i++) {
            const d         = getDate(i);
            const available = isDayAvailable(d);
            const btn       = document.createElement('button');
            btn.type      = 'button';
            btn.disabled  = !available;
            btn.className = 'btn schedule-date-btn flex-fill'
                          + (i === selectedIndex && available ? ' active' : '')
                          + (available ? '' : ' disabled');
            btn.innerHTML = `<span class="schedule-date-dow">${DAY_NAMES[d.getDay()]}</span>`
                          + `<span class="schedule-date-md">${MONTH_NAMES[d.getMonth()]} ${d.getDate()}</span>`;
            if (available) {
                btn.addEventListener('click', () => {
                    selectedIndex    = i;
                    dateInput.value  = formatDateValue(d);
                    renderDates();
                    updateTimeOptions(d);
                });
            }
            dateTrack.appendChild(btn);
        }
        prevBtn.disabled = offset <= 0;
        nextBtn.disabled = offset + DAYS_SHOWN >= TOTAL_DAYS;
    }

    // Only options within the selected day's open/close window stay enabled;
    // a fully closed/appointment-only day (getHoursForDay() === null) can't
    // actually be selected (renderDates() disables its button), but this
    // still runs for the initial default day in case it isn't available.
    // For today specifically, options before the one-hour buffer (see
    // getMinTimeToday()) are disabled too, so a customer can't book an
    // already-passed or too-soon slot.
    function updateTimeOptions(d) {
        const timeSelect = scheduleModal.querySelector('[name="preferred_time"]');
        if (!timeSelect) return;

        const hours   = getHoursForDay(d.getDay());
        const minTime = isSameDay(d, getDate(0)) ? getMinTimeToday() : null;
        let clearedSelection = false;

        Array.from(timeSelect.options).forEach(option => {
            if (!option.value) return; // "Choose a Time" placeholder always stays enabled
            const withinHours = !tourHours || (hours && option.value >= hours.start && option.value < hours.end);
            const pastBuffer  = minTime && option.value < minTime;
            const available   = withinHours && !pastBuffer;
            option.disabled = !available;
            if (!available && option.selected) clearedSelection = true;
        });

        if (clearedSelection) timeSelect.value = '';
    }

    function findFirstAvailableIndex() {
        for (let i = 0; i < TOTAL_DAYS; i++) {
            if (isDayAvailable(getDate(i))) return i;
        }
        return 0; // no available day in the window -- fall back rather than lock up the picker entirely
    }

    function initDates() {
        selectedIndex   = findFirstAvailableIndex();
        offset          = Math.max(0, Math.min(selectedIndex, TOTAL_DAYS - DAYS_SHOWN));
        dateInput.value = formatDateValue(getDate(selectedIndex));
        renderDates();
        updateTimeOptions(getDate(selectedIndex));
    }

    prevBtn.addEventListener('click', () => { if (offset > 0)                         { offset--; renderDates(); } });
    nextBtn.addEventListener('click', () => { if (offset + DAYS_SHOWN < TOTAL_DAYS)   { offset++; renderDates(); } });

    // ─── Tour type radios ─────────────────────────────────────────────────────

    function getSelectedTourType() {
        return scheduleModal.querySelector('[name="tour_type"]:checked')?.value ?? 'specialist';
    }

    tourTypeRadios.forEach(radio => {
        radio.addEventListener('change', () => {
            videoOption.style.display = radio.value === 'specialist' ? '' : 'none';
        });
    });

    // ─── Calendar ─────────────────────────────────────────────────────────────

    function updateCalendarLinks(dateVal, timeVal) {
        const form         = document.getElementById('scheduletourform');
        const locationName = form?.dataset.locationName  || 'Fischer Homes Tour';
        const locationAddr = form?.dataset.locationAddress || '';
        const title        = `Tour at ${locationName}`;

        const [year, month, day]  = dateVal.split('-');
        const [hours, minutes]    = timeVal.split(':');
        const endHours = String(parseInt(hours, 10) + 1).padStart(2, '0');
        const startStr = `${year}${month}${day}T${hours}${minutes}00`;
        const endStr   = `${year}${month}${day}T${endHours}${minutes}00`;

        const googleLink = document.getElementById('cal-google');
        if (googleLink) {
            googleLink.href = `https://calendar.google.com/calendar/render?action=TEMPLATE`
                + `&text=${encodeURIComponent(title)}`
                + `&dates=${startStr}/${endStr}`
                + `&location=${encodeURIComponent(locationAddr)}`;
        }

        const icsLink = document.getElementById('cal-ics');
        if (icsLink) {
            const ics = [
                'BEGIN:VCALENDAR',
                'VERSION:2.0',
                'PRODID:-//Fischer Homes//Schedule Tour//EN',
                'BEGIN:VEVENT',
                `SUMMARY:${title}`,
                `DTSTART:${startStr}`,
                `DTEND:${endStr}`,
                `LOCATION:${locationAddr}`,
                'END:VEVENT',
                'END:VCALENDAR',
            ].join('\r\n');
            const blob    = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
            icsLink.href     = URL.createObjectURL(blob);
            icsLink.download = 'fischer-homes-tour.ics';
        }
    }

    // ─── Step transitions ─────────────────────────────────────────────────────

    function showStep1() {
        step1.classList.remove('d-none');
        step2.classList.add('d-none');
    }

    function showStep2() {
        const timeSelect = scheduleModal.querySelector('[name="preferred_time"]');
        const timeText   = timeSelect?.options[timeSelect.selectedIndex]?.text ?? '';

        if (dateDisplay && dateInput.value) {
            const [year, month, day] = dateInput.value.split('-');
            dateDisplay.textContent  = `${month}/${day}/${year.slice(2)} at ${timeText}`;
        }

        updateCalendarLinks(dateInput.value, timeSelect?.value ?? '00:00');

        step1.classList.add('d-none');
        step2.classList.remove('d-none');
    }

    stepNextBtn.addEventListener('click', () => {
        const timeSelect = scheduleModal.querySelector('[name="preferred_time"]');
        if (!dateInput.value || !timeSelect?.value) {
            step1Error.style.display = '';
            return;
        }
        step1Error.style.display = 'none';
        showStep2();
    });

    editBtn.addEventListener('click', e => { e.preventDefault(); showStep1(); });

    // ─── Init ─────────────────────────────────────────────────────────────────

    scheduleModal.addEventListener('show.bs.modal', (event) => {
        initDates();
        showStep1();
        const trigger = event.relatedTarget;
        const isSelfGuided = trigger && trigger.dataset.tourType === 'self-guided';

        const activeNavTab = isSelfGuided ? selfGuidedNavTab : tourNavTab;
        if (activeNavTab) bootstrap.Tab.getOrCreateInstance(activeNavTab).show();

        tourTypeRadios.forEach(radio => {
            radio.checked = isSelfGuided ? radio.value === 'self-guided' : radio.value === 'specialist';
            if (radio.checked) radio.dispatchEvent(new Event('change'));
        });
    });
    initDates();
}
